export class Error400 extends Error {}

export class Error403 extends Error {}

export class Error404 extends Error {}

export class Error422 extends Error {}

export class ApiError extends Error {}
